import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed, watch, onUnmounted } from "vue";
import { expectSettings, getAllSettings, log } from "../snippet-util";
import { useGoogleMaps } from "@/store/googleMaps";
//import Login from "../components/login.vue";
import DatabaseTool from "../components/database-tool.vue";
import MapTool from "../components/map-tool.vue";
import ComparisonTool from "../components/comparison-tool.vue";
import DetailedView from "../components/detail-view.vue";
import Auth from "../components/auth.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'widget',
  setup(__props, { expose: __expose }) {
  __expose();

const settings = ref<Record<string, string>>({})
const state = ref<string>("map");
const gMaps = useGoogleMaps();

const showDetailedView = ref<boolean>(false);

let closeTimeout: ReturnType<typeof setTimeout> | null = null;


const STATES = [
    {label: "map", state: "map"},
    {label: "login", state: "login"},
    {label: "database", state: "database"},
    {label: "comparison", state: "comparison"},
];


const mediaQuery = ref<MediaQueryList>(matchMedia('(max-width: 800px)'))
const isMobile = ref(mediaQuery.value.matches);
function onMobileChange(ev: MediaQueryListEvent) {
    isMobile.value = ev.matches;
}
onMounted(() => {
    mediaQuery.value.addEventListener('change', onMobileChange);
})
onUnmounted(() => {
    mediaQuery.value.removeEventListener('change', onMobileChange);
})

function moveToLogin(from:string){
    //FOR LIVE
    // OPEN LOGIN PAGE
    //console.log("From:",from);
    if(from){
        //window.location.href = `https://alscrowd.org/auth#${from}`
        window.location.href = `https://alscrowd.busystaging.com/auth#${from}`
    }else{
        //window.location.href = `https://alscrowd.org/auth`
        window.location.href = `https://alscrowd.busystaging.com/auth`
    }

    //FOR TESTING
    //state.value = "login";
}

function closeDetailedView(){
    showDetailedView.value = false;
    gMaps.selectedOrgDetails = null
}

onMounted(async() => {
    log("Widget is mounted");
    settings.value = getAllSettings();
    // expectSettings("state");
    console.log("Settings:", settings.value['state']);
    if(settings.value['state'] === 'database'){
        state.value = 'database';
    }else if(settings.value['state'] == 'map'){
        state.value = "map"
    }else if(settings.value['state'] === 'comparison'){
        state.value = 'comparison';
    }else if(settings.value['state'] === 'login'){
        state.value = "login"
    }


    //FOR TESTING
    //state.value = 'database';
});

watch(()=> gMaps.selectedOrganization, ()=>{
    if(gMaps.selectedOrganization){
        //FOR LIVE
        //window.location.href = `https://alscrowd.org/database-table/#${gMaps.selectedOrganization}`;
        window.location.href = `https://alscrowd.busystaging.com/database-table/#${gMaps.selectedOrganization}`;

        //FOR TESTING
        //state.value = 'database';
    }
},{immediate:true, deep:true});

watch(()=> gMaps.selectedOrgDetails, ()=>{
    if(gMaps.selectedOrgDetails){
        showDetailedView.value = true;
    }
})

watch(() => gMaps.selectedOrgDetails, (newOrg) => {
  if (newOrg) {
    showDetailedView.value = true;
  }
});

const __returned__ = { settings, state, gMaps, showDetailedView, get closeTimeout() { return closeTimeout }, set closeTimeout(v) { closeTimeout = v }, STATES, mediaQuery, isMobile, onMobileChange, moveToLogin, closeDetailedView, onMounted, ref, computed, watch, onUnmounted, get expectSettings() { return expectSettings }, get getAllSettings() { return getAllSettings }, get log() { return log }, get useGoogleMaps() { return useGoogleMaps }, DatabaseTool, MapTool, ComparisonTool, DetailedView, Auth }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})